import script from "./org-tree-node.vue?vue&type=script&setup=true&lang=js"
export * from "./org-tree-node.vue?vue&type=script&setup=true&lang=js"

import "./org-tree-node.vue?vue&type=style&index=0&id=079711b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-079711b0"]])

export default __exports__